{
  "name": "padtools_ts",
  "version": "0.4.0",
  "type": "module",
  "engines": {
    "node": ">=22"
  },
  "browserslist": "> 0.5%, last 2 versions, not dead",
  "bin": {
    "padtools_ts": "dist/cli/cli.js"
  },
  "files": [
    "dist",
    "dist-web",
    "LICENSE",
    "README.md"
  ],
  "scripts": {
    "build": "rimraf dist && tsc",
    "prepublishOnly": "npm run build && npm run build:web",
    "format": "biome format --write .",
    "start": "tsx src/cli/cli.ts",
    "start:api": "tsx src/api/server.ts",
    "start:api:bun": "bun src/api/server.ts",
    "start:mcp": "tsx src/mcp/server.ts",
    "test": "jest",
    "test:bun": "bun test --exclude tests/web",
    "test:jest:bun": "node ./node_modules/jest/bin/jest.js --runInBand",
    "test:web": "playwright test",
    "test:web:headed": "playwright test --headed",
    "test:cov": "jest --coverage",
    "ci": "npm run check && npm run build && npm run build:web && npm run test:cov && npm run test:web && npm run convert:web:commands && npm run convert:web:render_options",
    "update-cli-golden-files": "tsx tests/cli/E2E/updateGoldenFile.ts",
    "update-spd-golden-files": "tsx tests/spd/E2E/updateGoldenFile.ts",
    "update-web-golden-files": "tsx tests/web/updateGoldenFile.ts",
    "lint": "biome lint .",
    "check": "biome check .",
    "check:apply": "biome check --write --unsafe .",
    "start:web": "parcel web/index.html --dist-dir temp/",
    "build:web": "rimraf dist-web && parcel build web/index.html --dist-dir dist-web",
    "build:web:gh-pages": "rimraf gh-pages/ && parcel build web/index.html --dist-dir gh-pages/ --public-url /padtools_ts/ && echo > gh-pages/.nojekyll",
    "convert:web:commands": "tsx web/utility/convert_commands.ts",
    "convert:web:render_options": "tsx web/utility/convert_render_options.ts",
    "deploy": "wrangler deploy",
    "dev:worker": "wrangler dev",
    "prepare": "husky"
  },
  "keywords": [
    "pad",
    "flowchart",
    "diagram",
    "generator",
    "cli",
    "svg",
    "typescript",
    "PAD"
  ],
  "author": "steelpipe",
  "license": "MIT",
  "description": "Simple tool to write PAD.",
  "dependencies": {
    "@hono/mcp": "^0.3.4",
    "@hono/node-server": "^2.1.1",
    "@hono/swagger-ui": "^0.6.1",
    "@hono/zod-openapi": "^1.6.3",
    "@modelcontextprotocol/sdk": "^1.32.1",
    "commander": "^15.0.0",
    "eastasianwidth": "^0.3.0",
    "fastmcp": "^4.23.5",
    "glob": "^14.0.3",
    "hono": "^4.13.14",
    "langium": "^4.3.1",
    "sanitize-html": "^2.18.1",
    "svgo": "^4.1.0",
    "xml-formatter": "^3.7.0",
    "zod": "^4.6.7"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.6.3",
    "@fullhuman/postcss-purgecss": "^8.0.0",
    "@parcel/packager-ts": "^2.16.4",
    "@parcel/transformer-inline-string": "^2.16.4",
    "@parcel/transformer-typescript-types": "^2.16.1",
    "@playwright/test": "^1.64.1",
    "@swc/core": "^1.16.20",
    "@swc/jest": "^0.2.39",
    "@types/jest": "^30.0.0",
    "@types/node": "^26.6.5",
    "@types/sanitize-html": "^2.16.2",
    "baseline-browser-mapping": "^2.11.30",
    "buffer": "^6.0.3",
    "entities": "^8.1.0",
    "husky": "^9.1.7",
    "jest": "^30.5.2",
    "langium-cli": "^4.4.0",
    "parcel": "^2.16.4",
    "postcss": "^8.5.30",
    "process": "^0.11.10",
    "rimraf": "^4.1.4",
    "tsx": "^4.23.15",
    "typescript": "^7.0.2",
    "wrangler": "^4.154.0"
  },
  "alias": {
    "entities/decode": "entities/dist/decode.js",
    "langium": "langium/lib/index.js",
    "vscode-languageserver-protocol": "vscode-languageserver-protocol/lib/browser/main.js",
    "vscode-languageserver-types": "vscode-languageserver-types/lib/umd/main.js",
    "vscode-jsonrpc/browser": "vscode-jsonrpc/lib/browser/main.js",
    "vscode-jsonrpc": "vscode-jsonrpc/lib/browser/main.js",
    "chevrotain": "chevrotain/lib/chevrotain.mjs",
    "chevrotain-allstar": "chevrotain-allstar/lib/index.js",
    "@chevrotain/regexp-to-ast": "@chevrotain/regexp-to-ast/lib/src/api.js",
    "@chevrotain/utils": "@chevrotain/utils/lib/src/api.js",
    "@chevrotain/gast": "@chevrotain/gast/lib/src/api.js",
    "@chevrotain/types": "@chevrotain/types/lib/api.js",
    "@chevrotain/cst-dts-gen": "@chevrotain/cst-dts-gen/lib/src/api.js",
    "vscode-uri": "vscode-uri/lib/umd/index.js"
  },
  "overrides": {
    "test-exclude": "7.0.1",
    "glob": "$glob"
  }
}
